<template>
  <div class="wdx login login-container text-center">
    <div class="row login-block">
      <div class="col">
        <h2 class="text-primary">Log in</h2>
      </div>
    </div>

    <div class="row login-block">
      <div class="w-100 d-flex justify-content-center">
        <div class="w-100 mt-1 text-secondary text-center font-18">
          Don't have password?
          <router-link to="/">Log in using email address</router-link>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <form class="px-4 mw-100" @submit="formSubmit">
        <div class="login-block form-start-block">
          <div class="row">
            <div class="col text-left font-14">
              Your User Name or Email Address
            </div>
          </div>
          <div class="row">
            <div class="col">
              <input
                type="text"
                class="form-control"
                v-model="email"
                :class="{ error: $v.email.$error }"
                data-testid="inputUsername"
              />
            </div>
          </div>
          <div class="row mt-4">
            <div class="col text-left font-14">Password</div>
          </div>
          <div class="row">
            <div class="col">
              <input
                type="password"
                class="form-control"
                v-model="password"
                :class="{ error: $v.password.$error }"
                data-testid="inputPassword"
              />
            </div>
          </div>
        </div>

        <div class="row mt-3" v-if="notification">
          <div class="col">
            <div class="notification p-3 text-center">
              {{ notification }}
            </div>
          </div>
        </div>

        <div class="row form-button">
          <div class="col">
            <button
              type="submit"
              class="btn btn-info btn-sm px-4"
              :disabled="loginLoading"
              data-testid="buttonLogin"
            >
              <div
                class="
                  spinner-border spinner-border-sm
                  text-primary
                  login-spinner
                "
                role="status"
                v-if="loginLoading"
              >
                <span class="sr-only">Loading...</span>
              </div>
              Login
            </button>
          </div>
        </div>

        <div class="row form-button">
          <div class="col">
            <button
              type="button"
              class="btn btn-secondary btn-sm px-4 btn-send-login-link"
              @click="sendEmail()"
              :disabled="sendLoading"
            >
              <div
                class="
                  spinner-border spinner-border-sm
                  text-primary
                  login-spinner
                  send-spinner
                "
                role="status"
                v-if="sendLoading"
              >
                <span class="sr-only">Loading...</span>
              </div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 80 72"
                xmlns="http://www.w3.org/2000/svg"
                class="mr-2 mb-1"
              >
                <path
                  d="M80 27.92V64C80 68.4 76.4 72 72 72H8C3.6 72 0 68.4 0 64L0.04 16C0.04 11.6 3.6 8 8 8H48.4C48.16 9.28 48 10.64 48 12C48 13.36 48.16 14.72 48.4 16H8L40 36L54.68 26.84C56.56 28.56 58.76 29.88 61.2 30.76L40 44L8 24V64H72V31.6C74.96 31 77.68 29.68 80 27.92ZM56 12C56 18.64 61.36 24 68 24C74.64 24 80 18.64 80 12C80 5.36 74.64 0 68 0C61.36 0 56 5.36 56 12Z"
                />
              </svg>
              Send me Login Link
            </button>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <div class="p-3 text-center text-secondary">
              If you are experiencing a problem with new login, try to use
              <a href="/login.aspx">a previous log in page</a>.
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import WdxBaseComponentMixin from '../../common/mixins/wdxBaseComponent';
import { required } from 'vuelidate/lib/validators';
import { MUTATION_REGISTRATION_EMAIL } from '../constants';
import loginComponentMixin from './loginComponentMixin';
import { mapGetters } from 'vuex';
export default {
  mixins: [WdxBaseComponentMixin, loginComponentMixin],
  data() {
    return {
      email: '',
      password: '',
      notification: null,
      showSendEmail: false,
      sendEmailClicked: false,
      loginLoading: false,
      sendLoading: false
    };
  },
  validations() {
    if (this.sendEmailClicked) {
      return {
        email: {
          required
        }
      };
    } else {
      return {
        email: {
          required
        },
        password: {
          required
        }
      };
    }
  },
  computed: {
    ...mapGetters([
      'registrationEmail'
    ]),
  },
  mounted: function () {
    this.email = this.registrationEmail;
  },
  methods: {
    formSubmit(e) {
      e.preventDefault();

      this.notification = null;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.loginLoading = true;
      this.$userService
        .loginUser(this.email, this.password)
        .then((response) => {
          this.loginLoading = false;
          if (response.data) {
            const res = response.data;
            if (res.Error) {
              this.notification = res.Error;
            } else if (res.CookieValue) {
              const expDate = new Date(res.CookieExpiration);
              document.cookie = `${res.CookieName}=${res.CookieValue}; path=${
                res.CookiePath
              }; samesite=${
                res.CookieSameSite
              }; expires=${expDate.toUTCString()}; secure=false;`;
              const redirectUrl = res.RedirectUrl;
              const defaultUrl = this.getRedirectUrl(res.DefaultUrl);
              if (redirectUrl) {
                location = redirectUrl;
              } else {
                location = defaultUrl;
              }
            } else {
              this.notification = 'There is an error.';
            }
          }
        })
        .catch((error) => {
          this.loginLoading = false;
          this.handleHttpError(error, true);
        });
    },

    backToInputEmail(e) {
      e.preventDefault();
      this.showSendEmail = false;
    },

    sendEmail() {
      this.sendEmailClicked = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.sendEmailClicked = false;
        return;
      }

      this.sendEmailClicked = false;

      this.sendLoading = true;
      this.$userService
        .sendLoginEmail(this.email)
        .then((response) => {
          this.sendLoading = false;
          const data = response.data;
          if (data) {
            if (data.Result) {
              this.$store.commit(MUTATION_REGISTRATION_EMAIL, this.email);
              this.$router.push({ name: 'emailSent' });
            } else {
              this.showErrorByLoginResult(data.CheckResult);
            }
          }
        })
        .catch((error) => {
          this.sendLoading = false;
          this.handleHttpError(error, true);
        });
    },

    showErrorByLoginResult(res) {
      if (res.UserNotFound) {
        this.notification = 'User with same email not exists in the system';
      }
    }
  }
};
</script>

<style scoped>
.login .send-spinner {
  margin-left: -115px;
}
</style>
